import * as Scrivito from "scrivito"
import { IconName } from "shared/ui/icon/__generated__/IconName"

export const FEATURE_OVERVIEW_ICONS = [
  IconName.FOLDERS,
  IconName.OPTIONS,
  IconName.IMPORT_EXPORT,
  IconName.DEVICES,
  IconName.PRODUCTS,
  IconName.CHATTING,
  IconName.PEOPLE,
  IconName.IMAGE_GALLERY
] as const

export const FeatureOverviewItemWidget = Scrivito.provideWidgetClass(
  "FeatureOverviewItemWidget",
  {
    attributes: {
      title: "string",
      subtitle: "string",
      icon: ["enum", { values: FEATURE_OVERVIEW_ICONS }]
    }
  }
)
